import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { SharedModule } from '@shared/shared.module';
import { throwIfAlreadyLoaded } from '@core/guards/module-import.guard';
import { AppComponent } from '../app.component';
import { environment } from '@environments/environment';
import { HttpInterceptorProviders } from '@core/http-interceptors';
import { UnderConstructionPageComponent } from './pages/under-construction-page.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { NotFoundPageComponent } from './pages/not-found-page.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthorizationDeniedPageComponent } from './pages/authorization-denied-page.component';
import { AuthorizationDeniedComponent } from './components/authorization-denied/authorization-denied.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    SharedModule
    
  ],
  providers: [HttpInterceptorProviders],
  entryComponents: [],
  declarations: [
    AppComponent,
    UnderConstructionPageComponent,
    UnderConstructionComponent,
    NotFoundPageComponent,
    NotFoundComponent,
    AuthorizationDeniedPageComponent,
    AuthorizationDeniedComponent
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
